export enum CONFIGURATION_SCOPES {
  GLOBAL = 'global',
  USER = 'user',
}
